import { sanitizeSameOriginPath } from "@sg-protect/core";

export const READ_SUCCESS_STEP = "read-success";
const CONSENT_CONFIRMED_STEPS = ["remediation", "skipped"];

// Steps of the setup flow that must still render their own page even once onboarding looks complete
// (e.g. a confirmation/error screen for a step the user just finished).
export const STEPS_THAT_STAY_ON_SETUP = new Set([...CONSENT_CONFIRMED_STEPS, READ_SUCCESS_STEP]);

export function resolveReturnTo(returnTo: string | null, fallback: string): string {
    return sanitizeSameOriginPath(returnTo) ?? fallback;
}

export function isSetupSuccessful(searchParams: URLSearchParams, isConsented: boolean): boolean {
    const step = searchParams.get("step") ?? "";

    return CONSENT_CONFIRMED_STEPS.includes(step) && isConsented && !searchParams.has("error");
}
